import { setTerm } from './helpers';

export const setIsDacha = setTerm('is_dacha');
